import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EPaymentStatus } from '../../types/payment';
import { EPaymentStateActions } from '../../constants/actionTypes/paymentStatusActions';

export const setPaymentStatus = actionGenerator<EPaymentStateActions.SET_STATUS, EPaymentStatus>(
  EPaymentStateActions.SET_STATUS,
);
export type TSetPaymentStatus = ReturnType<typeof setPaymentStatus>;

export const setPaymentId = actionGenerator<EPaymentStateActions.SET_ID, string>(EPaymentStateActions.SET_ID);
export type TSetPaymentId = ReturnType<typeof setPaymentId>;

export const resetPaymentState = actionGenerator<EPaymentStateActions.RESET_STATE>(EPaymentStateActions.RESET_STATE);
export type TResetPaymentState = ReturnType<typeof resetPaymentState>;
